import { CheckCircleIcon, TvIcon } from "@heroicons/react/24/solid";
import { type } from "os";
import "../styles/spinner.css"

type SuccessProps = {
    message: string
    setMessage: (message: string) => void
}

function SuccessNotification({message, setMessage}: SuccessProps) {
    return (
        <div className="success-wrapper h-2/3 w-2/3" onClick={() => setMessage("")}>
            <img src="/success_icon.svg" className="h-12 w-12"/>
            <p className="text-white text-lg">{message}</p>
        </div>
    )    
}

export default SuccessNotification;
